export default function Methodology() {
  return (
    <section
      id="methodik"
      data-testid="methodology-section"
      className="section-padding bg-[#0A0A0A] text-white border-b border-white/10"
    >
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-end">
          <div className="lg:col-span-7">
            <div className="overline mb-4" style={{ color: "#FF4747" }}>
              Methodik
            </div>
            <h2 className="font-display font-bold text-3xl sm:text-4xl md:text-5xl tracking-tight leading-[1.05] text-white">
              Ein klarer Pfad —<br />
              kein Methoden­zirkus.
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-base md:text-lg leading-relaxed text-white/70">
              Ich sorge dafür, dass aus Beratung messbarer Vertriebs­erfolg
              wird — nachvollziehbar für die Auftraggeber.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
